import { render, staticRenderFns } from "./LineItemsContainer.vue?vue&type=template&id=2fec7a2a&scoped=true"
import script from "./LineItemsContainer.vue?vue&type=script&lang=js"
export * from "./LineItemsContainer.vue?vue&type=script&lang=js"
import style0 from "./LineItemsContainer.vue?vue&type=style&index=0&id=2fec7a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fec7a2a",
  null
  
)

export default component.exports